export default __webpack_public_path__ + "static/media/runButton.1b9f56bb.svg";